//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'

//material-ui
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress, InputAdornment, IconButton, MuiThemeProvider, createMuiTheme, ListItem,
} from '@material-ui/core'

//style
import './AddEditDialog.scss'

import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers'
import CalendarToday from '@material-ui/icons/CalendarToday'
import MomentUtils from '@date-io/moment'
import moment from 'moment'
import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'

const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      underline: {
        '&::after': {
          borderBottomColor: '#777777',
          borderBottom: '2px solid #777777 !important',
        },
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#FF7800',
      },
      thumb: {
        backgroundColor: '#FF7800',
        borderColor: '#FF7800',
      },
    },
    MuiPickersClockNumber: {
      selected: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#777777',
      },
      selected: {
        backgroundColor: '#FF7800',
        '&:hover': {
          backgroundColor: '#FF7800',
        },
      },
      current: {
        color: '#777777',
      },
    },
    MuiPickersYear: {
      root: {
        color: '#777777',
        '&:hover': {
          color: '#FF7800',
        },
      },
      selected: {
        color: '#FF7800 !important',
        '&:hover': {
          color: '#FF7800',
        },
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#777777',
      },
    },
  },
})


@inject('translate')
@inject('internal')
@observer
export default class AddEditDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      loadingBtn: false,
      data: [],
      selected: [],
      name: '',
      code: '',
      discountType: 'percent',
      discountValue: 1,
      activeSince: moment().format('YYYY-MM-DD'),
      activeUntil: moment().add(1, 'month').format('YYYY-MM-DD'),
      is_always_visible: false,
      products: [],
      staticSets: [],
      categories: [],

      productListChanged: false,
      staticSetListChanged: false,
      categoryListChanged: false,

      productList: [],
      categoryListList: [],
      staticSetList: [],
    }
  }

  isEditMode = null

  componentDidMount() {

    this.isEditMode = toJS(this.props.internal.actionEdit)

    if (this.isEditMode.edit) {
      this.loadProductList()
      this.loadStaticSetList()
      this.loadCategoryList()
      //load detail fixneho setu
      this.loadItem()
    } else {
      this.setState({ loading: false })
    }
  }

  loadProductList = async () => {
    let response = await api({
      method: 'get',
      url: `lists/coupons/product-list`,
      authorization: this.props.internal.user.access_token,
    })

    if (response.success) {
      this.setState({
        productList: this.formatItems(response.data.data),
      })
    }
  }

  loadCategoryList = async () => {
    let response = await api({
      method: 'get',
      url: `lists/coupons/category-list`,
      authorization: this.props.internal.user.access_token,
    })

    if (response.success) {
      this.setState({
        categoryList: this.formatItems(response.data.data),
      })
    }
  }

  loadStaticSetList = async () => {
    let response = await api({
      method: 'get',
      url: `lists/coupons/static-set-list`,
      authorization: this.props.internal.user.access_token,
    })

    if (response.success) {
      this.setState({
        staticSetList: this.formatItems(response.data.data),
      })
    }
  }

  formatItems(items) {
    return items.map(item => ({
      value: item.id,
      label: item.name,
      children: this.formatItems(item.children || []),
    }))
  }

  loadItem = async () => {
    let recordId = toJS(this.props.internal.actionEdit.id)

    let response = await api({
      method: 'get',
      url: `lists/coupons/${recordId}`,
      authorization: this.props.internal.user.access_token,
    })

    if (response.success) {
      this.setState({
        loading: false,
        name: response.data.data.name,
        code: response.data.data.code,
        is_always_visible: response.data.data.is_always_visible,
        discountType: response.data.data.discount_type,
        discountValue: response.data.data.discount_value,
        activeSince: moment(response.data.data.active_since).format('YYYY-MM-DD'),
        activeUntil: moment(response.data.data.active_until).format('YYYY-MM-DD'),
        products: this.formatItems(response.data.data.products),
        staticSets: this.formatItems(response.data.data.static_sets),
        categories: this.formatItems(response.data.data.categories),
      })
    }
  }

  action = () => {
    let isEdit = toJS(this.props.internal.actionEdit.edit)
    this.setState({ loadingBtn: true })
    if (isEdit) {
      //update
      this.updateRecord()
    } else {
      //create
      this.createRecord()
    }
  }

  saveProducts = () => {
    if (false === this.state.productListChanged) {
      return Promise.resolve()
    }
    let recordId = toJS(this.props.internal.actionEdit.id)

    return api({
      method: 'put',
      url: `lists/coupons/${recordId}/pair-products`,
      authorization: this.props.internal.user.access_token,
      params: {
        product_id: this.state.products.map(item => item.value),
      },
    }).then(response => {
      if (true === response.success) {
        return Promise.resolve()
      }

      this.props.internal.setSnackbar(response.data.message, true, true);

      return Promise.reject(response.error);
    })

  }
  saveStaticSets = () => {
    if (false === this.state.staticSetListChanged) {
      return Promise.resolve()
    }
    let recordId = toJS(this.props.internal.actionEdit.id)

    return api({
      method: 'put',
      url: `lists/coupons/${recordId}/pair-static-sets`,
      authorization: this.props.internal.user.access_token,
      params: {
        static_set_id: this.state.staticSets.map(item => item.value),
      },
    }).then(response => {
      if (true === response.success) {
        return Promise.resolve()
      }

      this.props.internal.setSnackbar(response.data.message, true, true);

      return Promise.reject(response.error);
    })

  }
  saveCategories = () => {
    if (false === this.state.categoryListChanged) {
      return Promise.resolve()
    }
    let recordId = toJS(this.props.internal.actionEdit.id)

    return api({
      method: 'put',
      url: `lists/coupons/${recordId}/pair-categories`,
      authorization: this.props.internal.user.access_token,
      params: {
        category_id: this.state.categories.map(item => item.value),
      },
    }).then(response => {
      if (true === response.success) {
        return Promise.resolve()
      }

      this.props.internal.setSnackbar(response.data.message, true, true);

      return Promise.reject(response.error);
    })

  }


  handleChangeCheckbox = (field, event) => {
    this.setState({[field]: event.target.checked})
  }

  updateRecord = async () => {
    let name = this.name.state.value
    let code = this.code.state.value
    let discount_type = this.state.discountType
    let discount_value = String(this.discountValue.state.value).replace(',', '.').replace(/[^0-9.]/g, '')
    let active_since = this.state.activeSince
    let active_until = this.state.activeUntil
    let is_always_visible = this.state.is_always_visible
    if (name !== '' && code !== '' && discount_value > 0) {
      let recordId = toJS(this.props.internal.actionEdit.id)

      let update_data = await api({
        method: 'patch',
        url: `lists/coupons/${recordId}`,
        authorization: this.props.internal.user.access_token,
        params: {
          name,
          code,
          discount_type,
          discount_value,
          active_since,
          active_until,
          is_always_visible,
        },
      })

      if (update_data.success === true) {
        Promise.all([
          this.saveProducts(),
          this.saveStaticSets(),
          this.saveCategories(),
        ]).then(() => {
          this.props.internal.setSnackbar(update_data.data.message, true)
          this.setState({ loadingBtn: false })
          this.props.onClose(true)
        })
      } else {
        if (update_data.data.data.hasOwnProperty('errors')) {
          const firstKey = Object.keys(update_data.data.data.errors).shift()
          this.props.internal.setSnackbar(update_data.data.data.errors[firstKey][0], true)
        } else {
          this.props.internal.setSnackbar(update_data.data.message, true)
        }
        this.setState({ loadingBtn: false })
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }

  }

  createRecord = async () => {
    let name = this.name.state.value
    let code = this.code.state.value
    let discount_type = this.state.discountType
    let discount_value = String(this.discountValue.state.value).replace(',', '.').replace(/[^0-9.]/g, '')
    let active_since = this.state.activeSince
    let active_until = this.state.activeUntil
    let is_always_visible = this.state.is_always_visible
    if (name !== '' && code !== '' && discount_value > 0) {
      this.setState({ loadingBtn: true })
      let update_data = await api({
        method: 'post',
        url: `lists/coupons`,
        authorization: this.props.internal.user.access_token,
        params: {
          name,
          code,
          discount_type,
          discount_value,
          active_since,
          active_until,
          is_always_visible,
        },
      })

      if (update_data.success === true || (update_data.success === false && update_data.status === 201)) {
        this.props.internal.setSnackbar(update_data.data.message, true)
        this.setState({ loadingBtn: false })
        this.props.onClose(true)
      }
    } else {
      this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
      this.setState({ loadingBtn: false })
    }

  }
  editCategory = {}

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={() => this.props.onClose(false)}
        aria-labelledby="form-dialog-title"
        scroll={'body'}
      >
        <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
        {this.state.loading
          ?
          <div style={{ minHeight: '100px' }}>
            <CircularProgress className={'circular-progress'}/>
          </div>
          :
          <DialogContent>
            <CustomInput
              ref={ref => this.name = ref}
              text={this.props.translate.i18n.MODULES['LISTS_COUPONS'].TITLE}
              value={this.state.name}
              id={'title'}
              className={'w-100'}
              required
            />
            <CustomInput
              ref={ref => this.code = ref}
              text={this.props.translate.i18n.MODULES['LISTS_COUPONS'].CODE}
              value={this.state.code}
              id={'code'}
              className={'w-100'}
              required
            />
            <FormControl className={'w-100'}>
              <InputLabel>{this.props.translate.i18n.MODULES.LISTS_COUPONS.DISCOUNT_TYPE}</InputLabel>
              <Select
                className={'w-100'}
                value={this.state.discountType}
                onChange={event => this.setState({ discountType: event.target.value })}
              >
                {[
                  { value: 'percent', label: this.props.translate.i18n.MODULES.LISTS_COUPONS.DISCOUNT_TYPE_PERCENT },
                  { value: 'price', label: this.props.translate.i18n.MODULES.LISTS_COUPONS.DISCOUNT_TYPE_PRICE },
                ].map(({ value, label }) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
              </Select>
            </FormControl>
            <CustomInput
              ref={ref => this.discountValue = ref}
              text={this.props.translate.i18n.MODULES['LISTS_COUPONS'].DISCOUNT_VALUE}
              value={this.state.discountValue}
              id={'discountType'}
              className={'w-100'}
              required
            />
            <MuiThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={MomentUtils}
                locale={this.state.locale}
                moment={moment}
              >
                <div className={'date-pickers-container'}>
                  <div className={'date-picker'}>
                    <DatePicker
                      okLabel={
                        <span style={{ color: '#FF7800' }}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                      cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                      autoOk
                      showTabs={false}
                      allowKeyboardControl={false}
                      labelFunc={date =>
                        date ? date.format('DD.MM.YYYY') : ''
                      }
                      value={this.state.activeSince}
                      onChange={date => this.setState({ activeSince: date.format('YYYY-MM-DD') })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton style={{ padding: 6 }}>
                              <CalendarToday/>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className={'date-picker'}>
                    <DatePicker
                      okLabel={
                        <span style={{ color: '#FF7800' }}>{this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}</span>}
                      cancelLabel={<span>{this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}</span>}
                      autoOk
                      showTabs={false}
                      allowKeyboardControl={false}
                      labelFunc={date =>
                        date ? date.format('DD.MM.YYYY') : ''
                      }
                      value={this.state.activeUntil}
                      onChange={date => this.setState({ activeUntil: date.format('YYYY-MM-DD') })}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton style={{ padding: 6 }}>
                              <CalendarToday/>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </MuiPickersUtilsProvider>
            </MuiThemeProvider>
            <ListItem dense onChange={e => this.handleChangeCheckbox('is_always_visible', e)} className={'list-item'}>
              <input
                id={"is_always_visible"}
                type="checkbox"
                value={this.state.is_always_visible}
                defaultChecked={
                  this.state.is_always_visible
                }
              />
              <label htmlFor={"is_always_visible"}>{this.props.translate.i18n.MODULES.LISTS_COUPONS.IS_ALWAYS_VISIBLE}</label>
            </ListItem>
            {this.isEditMode && this.isEditMode.edit && (
              <div>
                <SelectSearch
                  className={'mt-10'}
                  options={this.state.productList}
                  value={this.state.products}
                  label={this.props.translate.i18n.MODULES.LISTS_COUPONS.PRODUCTS}
                  onChange={products => this.setState({ productListChanged: true, products })}
                  isMulti
                />

                <SelectSearch
                  className={'mt-10'}
                  options={this.state.staticSetList}
                  value={this.state.staticSets}
                  label={this.props.translate.i18n.MODULES.LISTS_COUPONS.STATIC_SETS}
                  onChange={staticSets => this.setState({ staticSetListChanged: true, staticSets })}
                  isMulti
                />

                <SelectSearch
                  className={'mt-10'}
                  options={this.state.categoryList}
                  value={this.state.categories}
                  label={this.props.translate.i18n.MODULES.LISTS_COUPONS.CATEGORIES}
                  onChange={categories => this.setState({ categoryListChanged: true, categories })}
                  isMulti
                />
              </div>
            )}
          </DialogContent>
        }
        <DialogActions>
          <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
          </Button>
          <CustomButton
            progressBar={this.state.loadingBtn}
            onClick={this.action}
            mystyle={'btn-white-bg'}
            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
            justText
            disabled={this.state.loading}
          />
        </DialogActions>
      </Dialog>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/Coupons/AddEdit/AddEditDialog.js